import { useEffect, useState } from "react";
import { getCaseTypes } from "../api/caseQuestions";
import { useSelector } from "react-redux";
import useErrorHandler from "./useErrorHandler";

const caseTypeCacheMap = new Map();

export default function useCaseTypesList() {
  const [caseTypeList, setCaseTypeList] = useState([]);
  const [error, setError] = useState(null);
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const token = user.token;

  useEffect(() => {
    if (caseTypeCacheMap.has(token)) {
      setCaseTypeList(caseTypeCacheMap.get(token));
    } else if (token) {
      getCaseTypes(token)
        .then(({ data }) => {
          setCaseTypeList(data.data);
          caseTypeCacheMap.set(token, data.data);
          setError(null);
        })
        .catch((error) => {
          errorHandler(error);
          setError(error);
        });
    }
  }, [token]);

  return { caseTypeList, error };
}
